<template>
  <ChooseAmzSpu
    :visible.sync="visible"
    :reserve="true"
    :amzSpuStatusList="['Y']"
    :title="title"
    :multiple="multiple"
    @confirm="spuConfirm"
    @close="close"
  />
</template>

<script>
import EditLoading from '@/mixins/edit-loading'
import ChooseAmzSpu from '../choose-amz-spu'

export default {
  mixins: [EditLoading],
  components: { ChooseAmzSpu },

  props: {
    visible: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    multiple: { type: Boolean, default: false },
    amzFirstDemandCode: { type: String, default: '' },
    title: { type: String, default: '' },
  },
  computed: {},
  watch: {},

  mounted() {},
  data() {
    return {
      form: {
        skuSalesChannel: '',
      },
      rules: {
        skuSalesChannel: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_data') || '请选择...',
            trigger: 'blur',
          },
        ],
      },
    }
  },
  methods: {
    close() {
      this.$emit('update:visible', false)
    },
    async spuConfirm({ data, skuSalesChannel }) {
      if (!data) return
      if (this.loadingOpen()) return
      this.$api
        .ecomAmzFirstDemandDetailAddSaveApi({
          spuCode: data.amzSpuCode,
          amzFirstDemandCode: this.amzFirstDemandCode,
          skuSalesChannel,
        })
        .then((res) => {
          this.loading = false
          this.loadingClose()
          this.$message({
            showClose: true,
            message: this.$l('INDEX.tips_save_ok') || res.msg,
            type: 'success',
          })
          this.reload()
        })
        .catch(() => {
          this.loadingClose()
        })
    },
    reload() {
      this.$emit('update:visible', false)
      this.$emit('reload')
    },
  },
}
</script>

<style></style>
